import { useDeleteOrderMutation } from '#api/orderApi.slice.ts';

export const useCancelOrder = () => {
    const [deleteOrder, { isLoading }] = useDeleteOrderMutation();
    const cancelOrder = async (orderId: string) => {
        return deleteOrder(orderId)
            .unwrap()
            .then(() => {
                return true;
            })
            .catch(e => {
                console.error(`Failed to cancel order ${orderId}`, e);
                return false;
            });
    };
    return { cancelOrder, isLoading };
};
